// 游戏图标组件 - 使用SVG绘制国风元素

interface IconProps {
  className?: string
  size?: number
}

// 玉玺图标
export function SealIcon({ className = '', size = 64 }: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* 玉玺底座 */}
      <rect x="12" y="44" width="40" height="12" rx="2" fill="#8B4513" />
      <rect x="12" y="44" width="40" height="12" rx="2" fill="url(#sealBaseGradient)" />
      
      {/* 玉玺主体 */}
      <rect x="16" y="20" width="32" height="24" rx="2" fill="#C9372C" />
      <rect x="16" y="20" width="32" height="24" rx="2" fill="url(#sealBodyGradient)" />
      
      {/* 玉玺顶部装饰 */}
      <path
        d="M20 20 L24 12 L40 12 L44 20 Z"
        fill="#B87333"
      />
      <path
        d="M20 20 L24 12 L40 12 L44 20 Z"
        fill="url(#sealTopGradient)"
      />
      
      {/* 龙纹装饰（简化） */}
      <circle cx="32" cy="8" r="4" fill="#D4A84B" />
      
      {/* 印文 */}
      <rect x="22" y="26" width="20" height="14" fill="#FFF8DC" opacity="0.9" />
      <text
        x="32"
        y="36"
        textAnchor="middle"
        fontSize="10"
        fontWeight="bold"
        fill="#C9372C"
      >
        霸
      </text>
      
      {/* 渐变定义 */}
      <defs>
        <linearGradient id="sealBaseGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#A0522D" />
          <stop offset="100%" stopColor="#8B4513" />
        </linearGradient>
        <linearGradient id="sealBodyGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#D9453A" />
          <stop offset="50%" stopColor="#C9372C" />
          <stop offset="100%" stopColor="#B52E24" />
        </linearGradient>
        <linearGradient id="sealTopGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#CD853F" />
          <stop offset="100%" stopColor="#B87333" />
        </linearGradient>
      </defs>
    </svg>
  )
}

// 竹简图标
export function BambooScrollIcon({ className = '', size = 64 }: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* 竹简卷轴左轴 */}
      <rect x="8" y="8" width="8" height="48" rx="4" fill="#8B4513" />
      <rect x="8" y="8" width="8" height="48" rx="4" fill="url(#bambooDark)" />
      
      {/* 竹简卷轴右轴 */}
      <rect x="48" y="8" width="8" height="48" rx="4" fill="#8B4513" />
      <rect x="48" y="8" width="8" height="48" rx="4" fill="url(#bambooDark)" />
      
      {/* 竹简片 */}
      <rect x="18" y="10" width="28" height="6" rx="1" fill="#D2B48C" />
      <rect x="18" y="10" width="28" height="6" rx="1" fill="url(#bambooLight)" />
      
      <rect x="18" y="18" width="28" height="6" rx="1" fill="#D2B48C" />
      <rect x="18" y="18" width="28" height="6" rx="1" fill="url(#bambooLight)" />
      
      <rect x="18" y="26" width="28" height="6" rx="1" fill="#D2B48C" />
      <rect x="18" y="26" width="28" height="6" rx="1" fill="url(#bambooLight)" />
      
      <rect x="18" y="34" width="28" height="6" rx="1" fill="#D2B48C" />
      <rect x="18" y="34" width="28" height="6" rx="1" fill="url(#bambooLight)" />
      
      <rect x="18" y="42" width="28" height="6" rx="1" fill="#D2B48C" />
      <rect x="18" y="42" width="28" height="6" rx="1" fill="url(#bambooLight)" />
      
      {/* 竹简文字（简化） */}
      <rect x="22" y="20" width="20" height="2" rx="1" fill="#8B4513" opacity="0.6" />
      <rect x="22" y="28" width="16" height="2" rx="1" fill="#8B4513" opacity="0.6" />
      <rect x="22" y="36" width="18" height="2" rx="1" fill="#8B4513" opacity="0.6" />
      <rect x="22" y="44" width="14" height="2" rx="1" fill="#8B4513" opacity="0.6" />
      
      {/* 绑绳 */}
      <rect x="16" y="22" width="32" height="2" rx="1" fill="#654321" />
      <rect x="16" y="38" width="32" height="2" rx="1" fill="#654321" />
      
      {/* 渐变定义 */}
      <defs>
        <linearGradient id="bambooDark" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#8B4513" />
          <stop offset="50%" stopColor="#A0522D" />
          <stop offset="100%" stopColor="#8B4513" />
        </linearGradient>
        <linearGradient id="bambooLight" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#E6D5AC" />
          <stop offset="100%" stopColor="#D2B48C" />
        </linearGradient>
      </defs>
    </svg>
  )
}

// 令牌图标
export function TokenIcon({ className = '', size = 64 }: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* 令牌主体 */}
      <rect x="20" y="8" width="24" height="36" rx="4" fill="#B87333" />
      <rect x="20" y="8" width="24" height="36" rx="4" fill="url(#tokenBody)" />
      
      {/* 令牌边框 */}
      <rect x="22" y="10" width="20" height="32" rx="2" stroke="#D4A84B" strokeWidth="1" fill="none" />
      
      {/* 令牌顶部装饰 */}
      <circle cx="32" cy="14" r="3" fill="#D4A84B" />
      
      {/* 令牌文字区域 */}
      <rect x="24" y="20" width="16" height="18" rx="2" fill="#F5F5DC" opacity="0.9" />
      
      {/* 令字 */}
      <text
        x="32"
        y="34"
        textAnchor="middle"
        fontSize="14"
        fontWeight="bold"
        fill="#8B4513"
      >
        令
      </text>
      
      {/* 令牌流苏 */}
      <path
        d="M28 44 L28 56"
        stroke="#C9372C"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M32 44 L32 58"
        stroke="#C9372C"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M36 44 L36 56"
        stroke="#C9372C"
        strokeWidth="2"
        strokeLinecap="round"
      />
      
      {/* 流苏穗子 */}
      <circle cx="28" cy="57" r="2" fill="#D4A84B" />
      <circle cx="32" cy="59" r="2" fill="#D4A84B" />
      <circle cx="36" cy="57" r="2" fill="#D4A84B" />
      
      {/* 渐变定义 */}
      <defs>
        <linearGradient id="tokenBody" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#CD853F" />
          <stop offset="50%" stopColor="#B87333" />
          <stop offset="100%" stopColor="#A0522D" />
        </linearGradient>
      </defs>
    </svg>
  )
}

// 宫殿/大厅背景装饰
export function PalaceDecoration({ className = '', size = 200 }: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size * 0.6}
      viewBox="0 0 200 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* 屋顶 */}
      <path
        d="M20 60 L100 20 L180 60"
        stroke="#8B4513"
        strokeWidth="3"
        fill="none"
      />
      <path
        d="M30 60 L100 25 L170 60"
        stroke="#D4A84B"
        strokeWidth="2"
        fill="none"
      />
      
      {/* 屋檐装饰 */}
      <circle cx="100" cy="20" r="5" fill="#C9372C" />
      <circle cx="100" cy="20" r="3" fill="#D4A84B" />
      
      {/* 柱子 */}
      <rect x="40" y="60" width="8" height="50" fill="#8B4513" />
      <rect x="152" y="60" width="8" height="50" fill="#8B4513" />
      
      {/* 柱子装饰 */}
      <rect x="38" y="65" width="12" height="4" fill="#D4A84B" />
      <rect x="38" y="100" width="12" height="4" fill="#D4A84B" />
      <rect x="150" y="65" width="12" height="4" fill="#D4A84B" />
      <rect x="150" y="100" width="12" height="4" fill="#D4A84B" />
      
      {/* 横梁 */}
      <rect x="30" y="75" width="140" height="6" fill="#A0522D" />
      
      {/* 门 */}
      <rect x="80" y="85" width="40" height="25" fill="#654321" />
      <rect x="82" y="87" width="16" height="21" fill="#4A3728" />
      <rect x="102" y="87" width="16" height="21" fill="#4A3728" />
      
      {/* 门环 */}
      <circle cx="90" cy="97" r="3" fill="#D4A84B" />
      <circle cx="110" cy="97" r="3" fill="#D4A84B" />
      
      {/* 台阶 */}
      <rect x="60" y="110" width="80" height="4" fill="#A0522D" />
      <rect x="50" y="114" width="100" height="4" fill="#8B4513" />
    </svg>
  )
}
